import { render, staticRenderFns } from "./BonusLeaderShare.vue?vue&type=template&id=7ccfb3eb&scoped=true"
import script from "./BonusLeaderShare.vue?vue&type=script&lang=js"
export * from "./BonusLeaderShare.vue?vue&type=script&lang=js"
import style0 from "./BonusLeaderShare.vue?vue&type=style&index=0&id=7ccfb3eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccfb3eb",
  null
  
)

export default component.exports